import SearchResultsWidgetRequest from '../api/SearchResultsWidgetSearchRequest.js';
export default (rfkId) => {
    const request = new SearchResultsWidgetRequest(rfkId);
    request.setRfkFlags(['questionsAndAnswersV2']);
    request.setQuestionsRelatedQuestionsLimit(5);
    request.setQuestionsExactAnswer({});
    return request;
};
